import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./PublicHeader.module.css";

const PublicHeader = () => {
  const pillClassName = ({ isActive }: { isActive: boolean }) =>
    isActive ? styles["pill-active"] : styles["pill"];

  return (
    <header className={styles["public-header"]}>
      <nav className={styles["pill-nav"]}>
        <NavLink to="/about" className={pillClassName}>
          About
        </NavLink>
        <NavLink to="/login" className={pillClassName}>
          Login
        </NavLink>
      </nav>
    </header>
  );
};

export default PublicHeader;
